import { SlotBookingModel, requestParam } from "../../Model/index";
import { CredimaxPaymentDetailsModel } from "./CredimaxPaymentDetailsModel";
import { FileToUpload } from "../../Model/Documents/FileToUpload";
import { AppointmentRequestModel } from "./AppointmentRequestModel";

export class GeneralBookingModel {
    Id: string;
    doctorId: string;
    doctorName: string;
    HOD: string;
    IS_BOOK_ALLOW: string;
    DisplayOrder: number;
    department: string;
    departmentId: string;
    date: string;
    scheduledStartTime: string;
    scheduledEndTime: string;
    consultationFee: string;
    token: string;
    NativeDoctorName: string;
    NativeDeptName: string;
    dayCode: number;
    patientName: string;
    MobileNo: string;
    Email: string;
    ImageByte: string;
    ScreenName: string;
    ServiceCode: string
    ServiceName: string;
    CurrencySymbol: string;
    departmentIdofChosenDoctor: string;
    BookingStatus: string;
    speciality: string;
    SlotPeriod: number;
    StartTime: Date;
    EndTime: Date;
    SessionCode: string;	
	designation : string;
    Qualification: string;
    color: string;
    VisitNo: string;
    VistiDate: string;
    totalTimeSlots: SlotBookingModel[] = [];
    CLINIC_CODE: string;
    patientId: string;
    SLOT: string;
    buttonActivity: string;
    PaymentTypeMode: string;
    credimaxPaymentDetails: CredimaxPaymentDetailsModel[] = [];
    requestParam: requestParam[] = [];
    AppointmentRequestDetils: AppointmentRequestModel;
    PrivatePaymentType: string;
    AppointmentRquestNo: string;
    CaptureData: string;
    AppReqPatientId: string;
    ScheduleAppNo: string;
    TitleCode: string;
    AlternateNo: string;
    Nationality: string;
    Town: string;
    AreaCode: string;
    flatno: string;
    EnteredDateofBirth: string;
    AlternateType: string;
    Sex: string;
    BlockNo: string;
    InsuredOrSelf: string;
    CivilIdDoc: FileToUpload;
    InsuredIdDoc: FileToUpload;
    IsDateEnteredManually: boolean;
    ISReschedule: string;
    ReScheduleDeptNumber: string;
    ReScheduleAppNumber: string;
    FirstName: string;
    FirstMiddleName: string;
    LastName: string;
    CivilIdFront: FileToUpload;
    CivilIdBack: FileToUpload;
    PassportFront: FileToUpload;
    PassportBack: FileToUpload;
    VisaAttach: FileToUpload;
    MOHAttach: FileToUpload;
    IsDocumentAttached: boolean = false;
    LocationId: string;
    IsPortalKiosk: string;
	Tap_id:string;
	NO_CHARGE:string;
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/model/booking/GeneralBookingModel.ts